export default __webpack_public_path__ + "97a5da8e940e95a68d09d81e63948c0e.svg";